import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation as useAppLocation } from '../../contexts/LocationContext';
import { db, collection, query, where, getDocs } from '../../firebase/config';

// ============================================================
// Embedded SVGs
// ============================================================
const icons = {
  hair: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/></svg>`,
  nails: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3-1.9 5.8a2 2 0 0 1-1.287 1.288L3 12l5.8 1.9a2 2 0 0 1 1.288 1.287L12 21l1.9-5.8a2 2 0 0 1 1.287-1.288L21 12l-5.8-1.9a2 2 0 0 1-1.288-1.287Z"/></svg>`,
  skin: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7 2.9 7 2.9s-2.29 6.16-2.29 6.16C3.57 10 3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"/><path d="M15.5 21c2.5 0 4.5-2.02 4.5-4.5 0-1.29-.64-2.5-1.91-3.53S15.5 6.5 15.5 6.5s-2.58 6.84-2.58 6.84c-1.27 1.03-1.92 2.24-1.92 3.53 0 2.48 2 4.5 4.5 4.5z"/></svg>`,
  lashes: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>`,
  spa: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 7.5a4.5 4.5 0 1 1 4.5 4.5M12 7.5A4.5 4.5 0 1 0 7.5 12M12 7.5V9m-4.5 3a4.5 4.5 0 1 0 4.5 4.5M7.5 12H9m7.5 0a4.5 4.5 0 1 1-4.5 4.5m4.5-4.5H15m-3 4.5v1.5"/></svg>`,
  search: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>`,
  mic: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" x2="12" y1="19" y2="22"/></svg>`,
  wand: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72Z"/><path d="m14 7 3 3"/><path d="M5 6v4"/><path d="M19 14v4"/><path d="M10 2v2"/><path d="M7 8H3"/><path d="M21 16h-4"/><path d="M11 3H9"/></svg>`,
  crosshair: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="22" x2="18" y1="12" y2="12"/><line x1="6" x2="2" y1="12" y2="12"/><line x1="12" x2="12" y1="6" y2="2"/><line x1="12" x2="12" y1="22" y2="18"/></svg>`,
  user: `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 7c-1.1 0-2.2.3-3.1.8L7.5 22h2.2l1.3-6.5L12 22l1-6.5L14.3 22h2.2l-1.4-12.2c-.9-.5-2-.8-3.1-.8h-2z"/></svg>`,
  star: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`,
  arrowRight: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>`
};

const FILTER_CATEGORIES = [
  { id: 'hair', svg: icons.hair, label: 'Hair' },
  { id: 'nails', svg: icons.nails, label: 'Nails' },
  { id: 'skin', svg: icons.skin, label: 'Skin' },
  { id: 'lashes', svg: icons.lashes, label: 'Lashes' },
  { id: 'spa', svg: icons.spa, label: 'Spa' },
];

const CATEGORY_LABEL = {
  hair: 'Hair',
  nails: 'Nails',
  skin: 'Skin',
  lashes: 'Lashes',
  spa: 'Spa',
};

const getTypeConfig = (type) => {
  switch (type) {
    case 'hair': return { svg: icons.hair, label: 'Hair' };
    case 'nails': return { svg: icons.nails, label: 'Nails' };
    case 'skin': return { svg: icons.skin, label: 'Skin' };
    case 'lashes': return { svg: icons.lashes, label: 'Lashes' };
    case 'spa': return { svg: icons.spa, label: 'Spa' };
    default: return { svg: icons.nails, label: 'Beauty' };
  }
};

// ============================================================
// Helpers
// ============================================================
const DEFAULT_CENTER = [-26.1076, 28.0567];
const DEFAULT_ZOOM = 13;

const haversineKm = (lat1, lng1, lat2, lng2) => {
  if ([lat1, lng1, lat2, lng2].some(v => v == null)) return null;
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
};

const formatDistance = (km) => {
  if (km == null) return '';
  if (km < 1) return `${(km * 1000).toFixed(0)} m`;
  return `${km.toFixed(1)} km`;
};

const inferCategory = (pro) => {
  const spec = (pro.specialization || pro.specializations?.[0] || '').toLowerCase();
  if (spec.includes('hair') || spec.includes('styl')) return 'hair';
  if (spec.includes('nail') || spec.includes('manicure')) return 'nails';
  if (spec.includes('lash') || spec.includes('brow')) return 'lashes';
  if (spec.includes('skin') || spec.includes('esthetic') || spec.includes('facial')) return 'skin';
  if (spec.includes('spa') || spec.includes('massage')) return 'spa';

  const haystack = [...(pro.services || []), ...(pro.specializations || [])].join(' ').toLowerCase();
  if (haystack.includes('hair') || haystack.includes('cut') || haystack.includes('color')) return 'hair';
  if (haystack.includes('nail') || haystack.includes('manicure') || haystack.includes('pedicure')) return 'nails';
  if (haystack.includes('lash') || haystack.includes('brow')) return 'lashes';
  if (haystack.includes('facial') || haystack.includes('skin') || haystack.includes('peel')) return 'skin';
  if (haystack.includes('spa') || haystack.includes('massage')) return 'spa';
  return 'hair';
};

const getProImage = (pro) => {
  if (pro.profileImage) return pro.profileImage;
  if (pro.image) return pro.image;
  if (Array.isArray(pro.media) && pro.media[0]?.type === 'image') return pro.media[0].url;
  if (pro.mediaLegacy?.url) return pro.mediaLegacy.url;
  return null;
};

const FALLBACK_IMG = 'https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=300&q=80';

// ============================================================
// Page
// ============================================================
export default function MapPage() {
  const navigate = useNavigate();
  const { currentLocation, requestLocation } = useAppLocation();

  const [pros, setPros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [leafletLoaded, setLeafletLoaded] = useState(false);
  const [mapCenter, setMapCenter] = useState(DEFAULT_CENTER);
  const [hasUserLocation, setHasUserLocation] = useState(false);

  const mapContainerRef = useRef(null);
  const mapInstance = useRef(null);
  const markersLayer = useRef(null);
  const markerRefs = useRef({});
  const activeRouteLine = useRef(null);
  const userMarkerRef = useRef(null);

  const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(''), 3000);
  };

  // ---------- Load pros (respecting showOnMap opt-out) ----------
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const snap = await getDocs(
          query(collection(db, 'users'), where('role', '==', 'professional'))
        );
        if (cancelled) return;
        const list = snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .filter(p =>
            p.coordinates?.lat != null &&
            p.coordinates?.lng != null &&
            p.showOnMap !== false
          );
        setPros(list);
      } catch (err) {
        console.error('Failed to load pros:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  // ---------- User location ----------
  useEffect(() => {
    if (currentLocation?.lat != null) {
      setMapCenter([currentLocation.lat, currentLocation.lng]);
      setHasUserLocation(true);
      return;
    }
    (async () => {
      try {
        const result = await requestLocation?.();
        if (result?.lat != null) {
          setMapCenter([result.lat, result.lng]);
          setHasUserLocation(true);
        }
      } catch (err) {
        console.warn('Location request failed:', err);
      }
    })();
  }, [currentLocation?.lat, currentLocation?.lng]);

  // ---------- Load Leaflet ----------
  useEffect(() => {
    if (!document.getElementById('leaflet-css')) {
      const link = document.createElement('link');
      link.id = 'leaflet-css';
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(link);
    }
    if (window.L) { setLeafletLoaded(true); return; }
    if (document.getElementById('leaflet-js')) return;
    const script = document.createElement('script');
    script.id = 'leaflet-js';
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.crossOrigin = '';
    script.onload = () => setLeafletLoaded(true);
    document.head.appendChild(script);
  }, []);

  // ---------- Init map ----------
  useEffect(() => {
    if (!leafletLoaded || !mapContainerRef.current || mapInstance.current) return;
    const L = window.L;

    mapInstance.current = L.map(mapContainerRef.current, {
      zoomControl: false,
      tap: true,
    }).setView(mapCenter, DEFAULT_ZOOM);

    L.tileLayer('https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      attribution: '&copy; Google Maps',
      maxZoom: 20,
    }).addTo(mapInstance.current);

    markersLayer.current = L.layerGroup().addTo(mapInstance.current);

    setTimeout(() => {
      if (mapInstance.current) mapInstance.current.invalidateSize();
    }, 300);

    return () => {
      if (mapInstance.current) {
        mapInstance.current.remove();
        mapInstance.current = null;
      }
    };
  }, [leafletLoaded]);

  // ---------- User marker ----------
  useEffect(() => {
    if (!mapInstance.current || !hasUserLocation) return;
    const L = window.L;
    mapInstance.current.flyTo(mapCenter, 14, { animate: true, duration: 1.2 });

    const userIconHtml = `
      <div class="relative w-[50px] h-[50px] marker-anim group z-50">
        <div class="absolute top-0 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-white rounded-full border-[3px] border-[#EFA9B6] overflow-hidden shadow-[0_10px_20px_rgba(239,169,182,0.4)] z-10 flex items-center justify-center text-[#EFA9B6]">
          ${icons.user}
        </div>
        <div class="absolute top-[46px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[8px] border-transparent border-t-[#EFA9B6] z-0"></div>
      </div>`;
    const userIcon = L.divIcon({
      className: 'bg-transparent border-none',
      html: userIconHtml,
      iconSize: [50, 60],
      iconAnchor: [25, 54],
      popupAnchor: [0, -55],
    });

    if (!userMarkerRef.current) {
      userMarkerRef.current = L.marker(mapCenter, { icon: userIcon, zIndexOffset: 1000 })
        .addTo(mapInstance.current)
        .bindPopup('<div class="font-bold text-[#EFA9B6] p-1 text-center whitespace-nowrap">You are here! 🙋‍♀️</div>');
    } else {
      userMarkerRef.current.setLatLng(mapCenter);
    }
  }, [mapCenter, hasUserLocation]);

  // ---------- Create marker ----------
  const createCustomMarker = (pro, index) => {
    const L = window.L;
    const category = inferCategory(pro);
    const config = getTypeConfig(category);
    const animationDelay = index * 0.08;
    const img = getProImage(pro) || FALLBACK_IMG;
    const proName = pro.businessName || pro.name || 'Professional';

    const initials = proName.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase();
    const distance = hasUserLocation
      ? haversineKm(mapCenter[0], mapCenter[1], pro.coordinates.lat, pro.coordinates.lng)
      : null;
    const distanceText = distance != null ? `${formatDistance(distance)} away` : '';

    const html = `
      <div class="relative w-[70px] h-[85px] marker-anim group" style="animation-delay: ${animationDelay}s">
        <div class="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-white border-2 border-[#FBE1E8] rounded-full w-8 h-8 flex items-center justify-center z-20 shadow-sm transition-transform group-hover:scale-110 group-hover:bg-[#EFA9B6] group-hover:text-white group-hover:border-[#EFA9B6] text-[#EFA9B6]">
          ${config.svg}
        </div>
        <div class="absolute top-2 left-1/2 transform -translate-x-1/2 w-16 h-16 bg-[#FFF5F6] rounded-full border-[3px] border-[#EFA9B6] overflow-hidden shadow-lg z-10 transition-all group-hover:border-[#CDBCE7] group-hover:shadow-xl group-hover:-translate-y-1 flex items-center justify-center">
          ${getProImage(pro)
            ? `<img src="${img}" alt="${proName}" class="w-full h-full object-cover" />`
            : `<span class="font-bold text-[#EFA9B6] text-lg">${initials}</span>`}
        </div>
        <div class="absolute top-[68px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[8px] border-r-[8px] border-t-[12px] border-transparent border-t-[#EFA9B6] z-0 transition-transform group-hover:-translate-y-1 group-hover:border-t-[#CDBCE7]"></div>
      </div>`;

    const icon = L.divIcon({
      className: 'bg-transparent border-none',
      html,
      iconSize: [70, 85],
      iconAnchor: [35, 80],
      popupAnchor: [0, -85],
    });

    const popupHtml = `
      <div class="bg-white pb-4 flex flex-col rounded-[24px] overflow-hidden border border-gray-50 shadow-sm w-[260px]">
        <div class="h-28 w-full relative bg-[#fdf2ef] flex items-center justify-center overflow-hidden">
          ${getProImage(pro)
            ? `<img src="${img}" class="w-full h-full object-cover" alt="${proName}">`
            : `<span class="font-bold text-[#EFA9B6] text-3xl">${initials}</span>`}
        </div>
        <div class="px-5 mt-4 text-left">
          <div class="flex justify-between items-start mb-1">
            <div class="text-[10px] font-bold text-[#EFA9B6] uppercase tracking-wider">${config.label}</div>
            ${distanceText ? `<div class="text-[9px] font-bold text-[#EFA9B6] bg-[#FFF5F6] px-2 py-0.5 rounded-full">${distanceText}</div>` : ''}
          </div>
          <h3 class="font-serif font-semibold text-[#1e1917] text-[18px] leading-tight mb-1 truncate">${proName}</h3>
          <p class="text-xs text-[#7a706b] mb-4">${(pro.specializations || [pro.specialization]).filter(Boolean).join(', ') || 'Beauty professional'}</p>
          <button data-pro-id="${pro.id}" class="pro-view-btn w-full bg-[#1e1917] hover:bg-[#382f2c] text-white font-medium py-3 rounded-full text-sm transition-colors flex items-center justify-center gap-2 group">
            View Profile <span class="group-hover:translate-x-1 transition-transform inline-flex">${icons.arrowRight}</span>
          </button>
        </div>
      </div>`;

    const marker = L.marker([pro.coordinates.lat, pro.coordinates.lng], { icon }).bindPopup(popupHtml);

    marker.on('popupopen', () => {
      const btn = document.querySelector(`.pro-view-btn[data-pro-id="${pro.id}"]`);
      if (btn) btn.onclick = () => navigate(`/professional/${pro.id}`);
    });

    return marker;
  };

  // ---------- Render markers ----------
  useEffect(() => {
    if (!leafletLoaded || !markersLayer.current || !mapInstance.current) return;
    markersLayer.current.clearLayers();
    markerRefs.current = {};

    const decorated = pros.map(p => ({ ...p, _category: inferCategory(p) }));

    const q = searchQuery.trim().toLowerCase();
    const searched = q
      ? decorated.filter(p =>
          (p.businessName || p.name || '').toLowerCase().includes(q) ||
          (p.specialization || '').toLowerCase().includes(q) ||
          (p.services || []).join(' ').toLowerCase().includes(q)
        )
      : decorated;

    const filtered = activeFilter === 'all'
      ? searched
      : searched.filter(p => p._category === activeFilter);

    filtered.forEach((pro, index) => {
      const marker = createCustomMarker(pro, index);
      marker.addTo(markersLayer.current);
      markerRefs.current[pro.id] = marker;
    });
  }, [pros, activeFilter, searchQuery, hasUserLocation, mapCenter, leafletLoaded]);

  // ---------- Actions ----------
  const centerMapOnUser = () => {
    if (!mapInstance.current) return;
    if (!hasUserLocation) {
      showToast('Enable location to center on you.');
      return;
    }
    mapInstance.current.flyTo(mapCenter, 16, { animate: true, duration: 1.5 });
    if (userMarkerRef.current) userMarkerRef.current.openPopup();
    showToast('Centered on your location.');
  };

  const findClosestBusiness = () => {
    if (!pros.length || !mapInstance.current || !window.L) return;
    if (!hasUserLocation) {
      showToast('Enable location to find the closest pro.');
      return;
    }
    const L = window.L;
    const filtered = activeFilter === 'all'
      ? pros
      : pros.filter(p => inferCategory(p) === activeFilter);

    let closest = null;
    let minDistance = Infinity;
    filtered.forEach(p => {
      const d = haversineKm(mapCenter[0], mapCenter[1], p.coordinates.lat, p.coordinates.lng);
      if (d != null && d < minDistance) {
        minDistance = d;
        closest = p;
      }
    });

    if (!closest) {
      showToast('No pros match that filter nearby.');
      return;
    }

    if (activeRouteLine.current) mapInstance.current.removeLayer(activeRouteLine.current);

    const closestLatLng = [closest.coordinates.lat, closest.coordinates.lng];
    activeRouteLine.current = L.polyline([mapCenter, closestLatLng], {
      color: '#EFA9B6',
      weight: 4,
      dashArray: '10, 10',
      opacity: 0.9,
    }).addTo(mapInstance.current);

    const bounds = L.latLngBounds([mapCenter, closestLatLng]);
    mapInstance.current.flyToBounds(bounds, { padding: [80, 80], duration: 1.5 });

    setTimeout(() => {
      const marker = markerRefs.current[closest.id];
      if (marker) marker.openPopup();
      showToast(`Closest: ${closest.businessName || closest.name} · ${formatDistance(minDistance)}`);
    }, 1600);
  };

  const nearestPros = useMemo(() => {
    if (!hasUserLocation) return [];
    return pros
      .map(p => ({
        ...p,
        _category: inferCategory(p),
        _distance: haversineKm(mapCenter[0], mapCenter[1], p.coordinates.lat, p.coordinates.lng),
      }))
      .filter(p => activeFilter === 'all' || p._category === activeFilter)
      .filter(p => p._distance != null)
      .sort((a, b) => a._distance - b._distance)
      .slice(0, 10);
  }, [pros, mapCenter, hasUserLocation, activeFilter]);

  // ---------- Render ----------
  return (
    <div className="relative w-full h-[100dvh] md:h-[calc(100vh-8rem)] bg-[#FCF8F9] font-sans text-[#1e1917] overflow-hidden">
      <style dangerouslySetInnerHTML={{__html: `
        @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap");
        body { font-family: 'Inter', sans-serif; }
        .font-serif { font-family: 'Playfair Display', serif; }

        .leaflet-tile-pane {
          filter: grayscale(1) sepia(1) hue-rotate(290deg) saturate(1.2) brightness(1.05) opacity(0.7);
        }
        .leaflet-popup-content-wrapper {
          border-radius: 24px !important;
          padding: 0 !important;
          overflow: hidden !important;
          box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04) !important;
          background: transparent !important;
        }
        .leaflet-popup-content { margin: 0 !important; width: auto !important; }
        .leaflet-control-attribution { display: none !important; }
        .leaflet-popup-tip { background: white !important; }

        .marker-anim {
          animation: bounceIn 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
          opacity: 0;
          transform-origin: bottom center;
        }
        @keyframes bounceIn {
          0% { transform: scale(0.1) translateY(20px); opacity: 0; }
          60% { transform: scale(1.1) translateY(-5px); opacity: 1; }
          100% { transform: scale(1) translateY(0); opacity: 1; }
        }
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}} />

      {/* Map */}
      <div ref={mapContainerRef} className="absolute inset-0 z-0 bg-[#FBE1E8]" />

      {/* Loading */}
      {loading && (
        <div className="absolute inset-0 z-[1500] flex items-center justify-center bg-[#FCF8F9]/80 backdrop-blur-sm">
          <div className="w-12 h-12 border-4 border-[#EFA9B6] border-t-transparent rounded-full animate-spin" />
        </div>
      )}

      {/* Toast */}
      <div className={`fixed top-24 left-1/2 transform -translate-x-1/2 bg-[#1e1917] text-white px-6 py-3 rounded-full shadow-2xl z-[2000] text-sm font-medium transition-opacity duration-300 pointer-events-none ${toastMessage ? 'opacity-100' : 'opacity-0'}`}>
        {toastMessage}
      </div>

      {/* Top overlay — search + chips, gradient fade under nav */}
      <div
        className="absolute top-0 left-0 w-full z-[1000] pointer-events-none flex flex-col gap-3 pt-3 pb-10 px-5"
        style={{
          background:
            'linear-gradient(to bottom, rgba(252,248,249,0.98) 0%, rgba(252,248,249,0.85) 45%, rgba(252,248,249,0) 100%)',
        }}
      >
        <div className="pointer-events-auto bg-white shadow-md rounded-[32px] px-5 py-3 flex items-center gap-3 w-full max-w-md mx-auto border border-[#FBE1E8]">
          <div className="bg-[#FFF5F6] text-[#EFA9B6] rounded-full w-10 h-10 flex items-center justify-center shrink-0">
            <span dangerouslySetInnerHTML={{ __html: icons.search }} />
          </div>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Find salons, spas, nails..."
            className="bg-transparent border-none outline-none w-full text-[#1e1917] placeholder-gray-400 font-medium text-[15px]"
          />
          {searchQuery ? (
            <button onClick={() => setSearchQuery('')} className="text-gray-400 hover:text-[#EFA9B6] transition-colors p-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          ) : (
            <button className="text-gray-400 hover:text-[#EFA9B6] transition-colors p-2">
              <span dangerouslySetInnerHTML={{ __html: icons.mic }} />
            </button>
          )}
        </div>

        <div className="pointer-events-auto w-full max-w-md mx-auto overflow-x-auto hide-scrollbar">
          <div className="flex gap-2.5 pb-2 px-1">
            <button
              onClick={() => setActiveFilter('all')}
              className={`whitespace-nowrap px-6 py-3 rounded-[32px] text-[13px] font-semibold shadow-sm transition-transform hover:scale-105 border ${
                activeFilter === 'all'
                  ? 'bg-[#EFA9B6] text-white border-[#EFA9B6]'
                  : 'bg-white text-[#7a706b] border-[#FBE1E8]'
              }`}
            >
              All
            </button>
            {FILTER_CATEGORIES.map(cat => (
              <button
                key={cat.id}
                onClick={() => setActiveFilter(cat.id)}
                className={`whitespace-nowrap px-6 py-3 rounded-[32px] text-[13px] font-semibold shadow-sm transition-transform hover:scale-105 border flex items-center gap-2 ${
                  activeFilter === cat.id
                    ? 'bg-[#EFA9B6] text-white border-[#EFA9B6]'
                    : 'bg-white text-[#7a706b] border-[#FBE1E8]'
                }`}
              >
                <span dangerouslySetInnerHTML={{ __html: cat.svg }} className="opacity-90" /> {cat.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom-right actions */}
      <div className="absolute bottom-32 md:bottom-8 right-6 z-[1000] flex flex-col gap-4 pointer-events-none">
        <button
          onClick={findClosestBusiness}
          className="pointer-events-auto bg-[#1e1917] w-[64px] h-[64px] rounded-[24px] shadow-[0_10px_25px_rgba(30,25,23,0.3)] flex items-center justify-center text-white hover:bg-[#382f2c] hover:-translate-y-1 transition-all border-2 border-white group"
          title="Find Closest Spot"
        >
          <span dangerouslySetInnerHTML={{ __html: icons.wand }} className="group-hover:scale-110 transition-transform" />
        </button>
        <button
          onClick={centerMapOnUser}
          className="pointer-events-auto bg-white w-[64px] h-[64px] rounded-[24px] shadow-lg flex items-center justify-center text-[#1e1917] hover:text-[#EFA9B6] hover:-translate-y-1 transition-all border border-gray-100"
          title="Center on Me"
        >
          <span dangerouslySetInnerHTML={{ __html: icons.crosshair }} />
        </button>
      </div>

      {/* Nearest strip */}
      {!loading && nearestPros.length > 0 && (
        <div className="absolute bottom-24 md:bottom-0 left-0 right-0 z-[1000] pointer-events-none pb-[max(0.75rem,env(safe-area-inset-bottom))]">
          <div className="pointer-events-auto px-4 pb-3">
            <div className="flex items-center justify-between mb-2 px-1">
              <span className="text-[11px] font-bold text-gray-700 uppercase tracking-wider">Nearest to you</span>
              <button onClick={() => navigate('/dashboard/search?near=1')} className="text-[11px] font-bold text-[#EFA9B6]">
                See all
              </button>
            </div>
            <div className="flex gap-3 overflow-x-auto hide-scrollbar pb-1">
              {nearestPros.map(p => {
                const img = getProImage(p);
                const initials = (p.businessName || p.name || '?').split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase();
                return (
                  <button
                    key={p.id}
                    onClick={() => navigate(`/professional/${p.id}`)}
                    className="shrink-0 w-[210px] bg-white rounded-2xl p-3 border border-gray-100 shadow-sm hover:shadow-md transition-all text-left flex items-center gap-3"
                  >
                    <div className="w-12 h-12 rounded-full bg-[#FFF5F6] border-2 border-[#FBE1E8] overflow-hidden flex items-center justify-center shrink-0">
                      {img
                        ? <img src={img} alt="" className="w-full h-full object-cover" />
                        : <span className="text-[#EFA9B6] font-bold text-sm">{initials}</span>}
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="text-[13px] font-bold text-gray-900 truncate">{p.businessName || p.name}</p>
                      <p className="text-[10px] text-gray-500 truncate">
                        {p._distance != null ? formatDistance(p._distance) : ''}
                        {p._distance != null && ' · '}
                        {CATEGORY_LABEL[p._category] || 'Beauty'}
                      </p>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Empty state */}
      {!loading && pros.length === 0 && (
        <div className="absolute inset-0 z-[1200] flex items-center justify-center bg-[#FCF8F9]/90 backdrop-blur-sm">
          <div className="max-w-sm mx-4 bg-white rounded-3xl p-8 text-center shadow-xl border border-gray-100">
            <div className="w-16 h-16 bg-[#FFF5F6] rounded-full flex items-center justify-center mx-auto mb-4 text-[#EFA9B6]">
              <span dangerouslySetInnerHTML={{ __html: icons.crosshair }} />
            </div>
            <h3 className="font-serif font-bold text-xl text-gray-900 mb-2">No pros on the map yet</h3>
            <p className="text-sm text-gray-500 mb-6">
              We're still populating studio locations. Discover professionals the usual way in the meantime.
            </p>
            <button
              onClick={() => navigate('/dashboard/search')}
              className="w-full bg-[#1e1917] text-white py-3 rounded-full font-bold text-sm hover:bg-[#382f2c] transition-colors"
            >
              Go to Discover
            </button>
          </div>
        </div>
      )}
    </div>
  );
}